// extracted by mini-css-extract-plugin
export default {"wordBox":"WrapperWord_wordBox__Xq+WC"};